module.exports = __webpack_public_path__ + "img/start_triangle.48e056f4.svg";